<script>
  import { Line } from 'vue-chartjs'
  import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
  import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
  import { random } from '@/shared/utils'
  import DateFormatter from '../plugins/dateFormatter'
import dateFormatter from '../plugins/dateFormatter';
import getTrafficDataAttributes from '../plugins/getTrafficDataAttributes'

  export default {
    extends: Line,
    props: ['height', 'renderData', 'overview', 'selectedSites','selectedPlatform','selectedSource','selectedCategory','selectedOption'],
    data () {
      return {
        dates: [],
        ticksLimit : 0,
        filterDates : [],
        chartData : {},
        onedioTotalArray: [],
        onedioTotal: 0,
        datasetArray: [],
        mycolor: '#000',
        facebookColor: '#023AA3',
        yandexColor: '#EF2E2E',
        relapColor: '#2DA87D',
        adxColor: '#FFA000',
        adformColor: '#BC4C9E',
        forColor: '',
        generalTotal: 0,
        onedioruDatas: '',
        onediocoDatas: '',
        onediocomDatas: '',
        overallData:[],
        maxValue:0,
        uniqueAttributes:[],
        categoryOptions:[],
        overviewOptions:[],
        platformOptions:[],
        sourceOption:[],
      }
    },
    watch: {
      async renderData(newData, oldData){
        this.filterDates = await this.$store.state.trafficData.filterDates
        await this.changeChartData()
        await this.$events.fire('SET_GENERAL_TOTAL_TRAFFIC',this.generalTotal)
      },
      async overview(newData,oldData){
        await this.changeChartData()
      },
      async selectedSites(newData,oldData){
          await this.changeChartData()
      },
      selectedCategory(newData,oldData){
     this.changeChartData()
      },
      selectedSource(newData,oldData){
        this.changeChartData()
      },
      selectedPlatform(newData,oldData){
        this.changeChartData()
      },
      selectedOption(newData,oldData){
       this.changeChartData()
      }
    },
    async created(){
        this.uniqueAttributes=(await getTrafficDataAttributes()).data
        this.categoryOptions=this.uniqueAttributes.category
        this.sourceOption=this.uniqueAttributes.source
        this.platformOptions=this.uniqueAttributes.platform
        /* this.overviewOptions=this.uniqueAttributes.metric */
        this.filterDates = await this.$store.state.trafficData.filterDates
        this.overallData=await this.$store.state.trafficData.datas[0]
        await this.changeChartData()
        await this.$events.fire('SET_GENERAL_TOTAL_TRAFFIC',this.generalTotal)
    },
    
    methods: {
      async changeChartData(){
          const brandSuccess = getStyle('--success') || '#4dbd74'
          const brandInfo = getStyle('--info') || '#20a8d8'
          const brandDanger = getStyle('--danger') || '#f86c6b'
          this.maxValue=0
          let dataInfo = false
          if(this.$store.state.trafficData.filterDates){
            //set data
            this.chartData =await this.$store.state.trafficData.datas[0]
            this.onediocomDatas = await this.chartData.onediocomDatas
            this.onediocoDatas = await this.chartData.onediocoDatas
            this.onedioruDatas = await this.chartData.onedioruDatas
            this.filterDates = await this.$store.state.trafficData.filterDates
            this.datasetArray = []
            this.generalTotal = 0
            this.selectedSites.forEach(async element => { 
              if(element === 'onediocom'){
                await this.filterSites(this.onediocomDatas,'onedio.com')
              }
              else if(element === 'onedioco'){
                await this.filterSites(this.onediocoDatas, 'onedio.co')
              }
              else if(element === 'onedioru'){
                await this.filterSites(this.onedioruDatas, 'onedio.ru')
              }
            });
            //For bounce rate average calculate
            if(this.overview==="bouncerate" && this.selectedSites && this.selectedOption){
              this.generalTotal/= await (this.selectedSites.length)
              this.generalTotal/= this.selectedOption==='Platform'?this.selectedPlatform.length:(this.selectedOption==='Source'?this.selectedSource.length:this.selectedCategory)
              if(this.filterDates){
                this.generalTotal/= await this.filterDates.length
              }
            }
            this.generalTotal=this.generalTotal.toFixed(2)
            await this.$events.fire('SET_GENERAL_TOTAL_TRAFFIC',this.generalTotal)
            let maxValue = 0
            function getMaximum(params) {
              params = Number(params)
                if (params > maxValue){
                    maxValue = params;
                }
            }   
            Object.keys(this.datasetArray).forEach((item)=> {
             this.datasetArray[item].data.forEach(async (element) => {
              getMaximum(element)
              })
            })
            this.maxValue=maxValue
            this.changeChart();
            }
      },
     async  filterSites(site,siteName){
        let count=0
        this.onedioTotalArray = []
        this.onedioTotal=0
        let option=''
        if(this.selectedOption==='Platform'){
          option=this.selectedPlatform
        }
        else if(this.selectedOption==='Source'){
          option=this.selectedSource
        }
        else if(this.selectedOption==='Category'){
          option=this.selectedCategory
        }
        for(let k=0;k<option.length;k++){
          this.labelName=siteName + ' ' + option[k]
          this.forColor=option[k]
          this.onedioTotalArray=[]
          this.filterDates.forEach(async date =>{
            this.onedioTotal=0
            for(let j=0;j<site.length;j++){
              if(site[j].metric===this.overview && dateFormatter(site[j]['trafic_date'])===date ){
                if(option[k]===site[j].source || (option[k]==='No Source' && site[j].source==='-')){
                   if(["pageview","user","session"].includes(this.overview)){
                        this.onedioTotal+=Number(site[j]._value)/1000
                    }
                    else{
                        this.onedioTotal+=Number(site[j]._value)
                    }
                }
                else if(option[k]===site[j].platform || (option[k]==='No Platform' && site[j].platform==='-')){
                   if(["pageview","user","session"].includes(this.overview)){
                        this.onedioTotal+=Number(site[j]._value)/1000
                    }
                    else{
                        this.onedioTotal+=Number(site[j]._value)
                    }
                }
                else if(option[k]===site[j].category || (option[k]==='No Category' && site[j].category==='-')){
                   if(["pageview","user","session"].includes(this.overview)){
                        this.onedioTotal+=Number(site[j]._value)/1000
                    }
                    else{
                        this.onedioTotal+=Number(site[j]._value)
                    }
                }
              }
            }
            this.onedioTotal=Number(this.onedioTotal).toFixed(2)
            this.generalTotal+=Number(this.onedioTotal)
            this.onedioTotalArray.push(this.onedioTotal)
            //color part
          if(siteName==='onedio.com'){
             if(['No Source','No Platform','No Category'].includes(this.forColor)){
                this.mycolor = this.facebookColor
              }else if(['mobile','device', 'yemek'].includes(this.forColor)){
                this.mycolor = this.yandexColor
              }else if(['desktop','app','goygoy'].includes(this.forColor)){
                this.mycolor = this.relapColor
              }else if(['seo','organic', 'iq'].includes(this.forColor)){
                this.mycolor = this.adxColor
              }else if(['fb','amp', 'com'].includes(this.forColor)){
                this.mycolor = this.adxColor
              }else if(['fb-paid', 'google-news','gundem'].includes(this.forColor)){
                this.mycolor =  '#FF4500'
              }else if(['instagram-bridge','push-notification','test'].includes(this.forColor)){
                this.mycolor =  '#CD5C5C'
              }
              else if(['branded','inspo'].includes(this.forColor)){
                 this.mycolor =  '#FF69B4'
              }
              else if(['googleapis'].includes(this.forColor)){
                  this.mycolor =  '#8B4513'
              }
              else if(['onediocom'].includes(this.forColor)){
                  this.mycolor =  '#FFF8DC'
              }
              else if(['unbranded'].includes(this.forColor)){
                  this.mycolor =  '#778899'
              }
          }
          else if(siteName==='onedio.co'){
           if(['No Source','No Platform','No Category'].includes(this.forColor)){
                this.mycolor = '#6a65d8'
             }else if(['mobile','device', 'yemek'].includes(this.forColor)){
                this.mycolor ='#ca3e47'
               }else if(['desktop','app','goygoy'].includes(this.forColor)){
                this.mycolor = '#94DE00'
              }else if(['seo','organic', 'iq'].includes(this.forColor)){
                this.mycolor = '#e8751a'
             }else if(['fb','amp', 'com'].includes(this.forColor)){
                this.mycolor =  '#ca5fa6'
            }else if(['fb-paid', 'google-news','gundem'].includes(this.forColor)){
                this.mycolor =  '#FF7F50'
              }else if(['instagram-bridge','push-notification','test'].includes(this.forColor)){
                this.mycolor =  '#F08080'
              }
              else if(['branded','inspo'].includes(this.forColor)){
                 this.mycolor =  '#FF1493'
              }
              else if(['googleapis'].includes(this.forColor)){
                  this.mycolor =  '#A0522D'
              }
              else if(['onediocom'].includes(this.forColor)){
                  this.mycolor =  '#FFEBCD'
              }
              else if(['unbranded'].includes(this.forColor)){
                  this.mycolor =  '#808080'
              }
          }
          else if(siteName==='onedio.ru'){
           if(['No Source','No Platform','No Category'].includes(this.forColor)){
                this.mycolor = '#010059'
              }else if(['mobile','device', 'yemek'].includes(this.forColor)){
                this.mycolor = '#ff7a8a'
              }else if(['desktop','app','goygoy'].includes(this.forColor)){
                this.mycolor ='#97de95'
              }else if(['seo','organic', 'iq'].includes(this.forColor)){
                this.mycolor ='#ffd700'
              }else if(['fb','amp', 'com'].includes(this.forColor)){
                this.mycolor =  '#ba78cd'
              }else if(['fb-paid', 'google-news','gundem'].includes(this.forColor)){
                this.mycolor =  '#FF6347'
              }else if(['instagram-bridge','push-notification','test'].includes(this.forColor)){
                this.mycolor =  '#FA8072'
              }
              else if(['branded','inspo'].includes(this.forColor)){
                 this.mycolor =  '#C71585'
              }
              else if(['googleapis'].includes(this.forColor)){
                  this.mycolor =  '#A52A2A'
              }
              else if(['onediocom'].includes(this.forColor)){
                  this.mycolor =  '#FFE4C4'
              }
              else if(['unbranded'].includes(this.forColor)){
                  this.mycolor =  '#696969'
              }
          }
        })
         const dataSetItem = 
        {
          label: this.labelName,
          backgroundColor: hexToRgba(this.mycolor, 5),
          borderColor: this.mycolor,
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.onedioTotalArray
        }
        this.datasetArray.push(dataSetItem)
        }
    await this.$events.fire('SET_GENERAL_TOTAL_TRAFFIC',this.generalTotal)
      },
      date_sort(a, b) {
        return new Date(a.trafic_date).getTime() - new Date(b.trafic_date).getTime();
      },
      filter_date_sort(a, b) {
        return new Date(a).getTime() - new Date(b).getTime();
      },
      changeChart(){
        const brandSuccess = getStyle('--success') || '#4dbd74'
        const brandInfo = getStyle('--info') || '#20a8d8'
        const brandDanger = getStyle('--danger') || '#f86c6b'
        this.renderChart({
          labels: this.filterDates,
          datasets: this.datasetArray 
        }, {
          tooltips: {
            enabled: false,
            custom: CustomTooltips,
            intersect: true,
            mode: 'index',
            position: 'nearest',
            callbacks: {
              labelColor: function (tooltipItem, chart) {
                return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
              }
            }
          },
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                maxTicksLimit: 18,
                stepSize: 1,
              },
              gridLines: {
                drawOnChartArea: true
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: false,
                maxTicksLimit: this.ticksLimit,
                stepSize: 1,
                max: this.maxValue
              },
              gridLines: {
                display: true
              }
            }]
          },
          elements: {
            point: {
              radius: 0,
              hitRadius: 10,
              hoverRadius: 4,
              hoverBorderWidth: 3
            }
          }
        })
      }
    }
  }
</script>
